import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout({ kind, jobId, offerteId }) {
  try {
    const { data } = await api.post("/payments/checkout", {
      kind,
      job_id: jobId || null,
      offerte_id: offerteId || null,
      origin_url: window.location.origin,
    });
    if (data.url) {
      window.location.href = data.url;
    } else {
      toast.error("Geen betaal-URL ontvangen.");
    }
  } catch (e) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Betaling starten mislukt.");
  }
}
